import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/resources/components/ResourcesClient.tsx");
